import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { addressToString } from '@debbie/common/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const DebtorUpdateDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(DebtorUpdateDetailsContent, { blamelog: blamelog })))));
};
const DebtorUpdateDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.DebtorUpdateName:
            return React.createElement(DebtorUpdateNameContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdatePhone:
            return React.createElement(DebtorUpdatePhoneContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateAddress:
            return React.createElement(DebtorUpdateAddressContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateEmail:
            return React.createElement(DebtorUpdateEmailContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateCourt:
            return React.createElement(DebtorUpdateCourtContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateBirthdate:
            return React.createElement(DebtorUpdateBirthdateContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateCVR:
            return React.createElement(DebtorUpdateCVRContent, { blamelog: blamelog });
        case BlameLogType.DebtorUpdateCPR:
            return React.createElement(DebtorUpdateCPRContent, { blamelog: blamelog });
        case BlameLogType.DebtorWebLoginEId:
            return React.createElement(DebtorWebLoginEIdContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const DebtorUpdateNameContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorUpdatePhoneContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    if (details == null) {
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.newValue)),
            React.createElement("td", null,
                React.createElement("i", null, lang.blameLogs.cleared))));
    }
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details.number || `${details}`)));
};
const DebtorUpdateAddressContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    if (details == null) {
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.newValue)),
            React.createElement("td", null,
                React.createElement("i", null, lang.blameLogs.cleared))));
    }
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, addressToString(details))));
};
const DebtorUpdateEmailContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorUpdateCourtContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorUpdateBirthdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorUpdateCVRContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorUpdateCPRContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.newValue)),
        React.createElement("td", null, details || React.createElement("i", null, lang.blameLogs.cleared))));
};
const DebtorWebLoginEIdContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.source)),
            React.createElement("td", null, details.identityscheme))));
};
//# sourceMappingURL=DebtorUpdateDetails.js.map